/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetAssetTypesOutputJsonApiModel = {
  id: "",
  "asset-types": {
    jsonApi: "hasMany",
    type: "asset-types",
  },
};
